import { css } from '@emotion/core';
import { colorsPalette, hexToRgba } from '../../../../styles/colors';
import { typography, fontWeights } from '../../../../styles/typography';
import { MediaQueries } from '../../../../styles/Grid';

export const sectionTitle = css({
  h2: {
    color: colorsPalette.phasetxt,
    fontSize: '40PX',
    fontWeight: '300',
    lineHeight: '48px',
    letterSpacing: '-0.3px',
    marginBottom: 48,
    marginTop: 16,
    [MediaQueries.lg]: {
      marginBottom: 32,
      color: colorsPalette.greytext,
    },
    [MediaQueries.md]: {
      marginBottom: 30,
      color: colorsPalette.greytext,
    },
    [MediaQueries.sm]: {
      marginBottom: 44,
      color: colorsPalette.phasetxt,
    },
  },
});

export const bgdarkgrey = css({
  inset: '0',
  border: '0',
  background: colorsPalette.grey,
  overflow: 'hidden',
  marginLeft: '12px',
  marginRight: '12px',
  borderRadius: '0',
  width: '100%',
  zIndex: 1,
  outline: 'none',
  padding: '0',
  h4: {
    cursor: 'pointer',
  },
  [MediaQueries.lgAndUp]: {
    marginTop: '15px',
  },
});

export const goBackButtonContainer = css({
  marginBottom: 8,
  color: colorsPalette.white,

  [MediaQueries.md]: {
    position: 'absolute',
    top: '50px',
  },
});

export const goBackMobileButtonContainer = css({
  position: 'absolute',
  top: '25px',
  left: '0',
});

export const goBackButton = css(typography.effra16, {
  border: 0,
  background: colorsPalette.transparent,
  color: colorsPalette.white,
  display: 'flex',
  alignItems: 'center',
  padding: 0,
  cursor: 'pointer',
});

export const goBackButtonLabel = css({
  marginLeft: 10,
});

export const mainlistsection = css({});

export const gridlist = css({
  position: 'relative',
  zoom: 1,
  overflowY: 'scroll',
  display: 'flex',
  width: '100%',

  '.gridlistsec': {
    display: 'flex',
    flexWrap: 'wrap',
    paddingBottom: '50px',
    width: '100%',
  },

  '@media only screen and (min-device-width: 1441px) and (max-device-width: 2048px)': {
    maxHeight: 'unset',
  },

  '@media screen and (min-width: 1440px)': {
    maxHeight: 'unset',
  },

  ':: -webkit-scrollbar': {
    width: '5px',
  },

  ':: -webkit-scrollbar-track': {
    background: colorsPalette.black,
  },

  ':: -webkit-scrollbar-thumb': {
    background: colorsPalette.black,
  },
});

export const topItemsbase = css({
  width: '50%',
});

// export const mainItems = css({
//   color: 'Blue',
//   a: {
//     color: 'red',
//   },
// });

export const subItemshead = css({
  color: colorsPalette.white,
  marginBottom: '48px',

  '.sub-item-count': {
    color: colorsPalette.pinktext,
    marginBottom: '16px',
    lineHeight: '24px',
    display: 'inline-block',
    fontSize: '14px',
    [MediaQueries.lg]: {
      color: colorsPalette.greytext,
    },
    [MediaQueries.md]: {
      color: colorsPalette.greytext,
    },

    a: {
      color: colorsPalette.pinktext,
      textDecoration: 'none',
      [MediaQueries.lg]: {
        color: colorsPalette.greytext,
      },
      [MediaQueries.md]: {
        color: colorsPalette.greytext,
      },
    },
  },

  'a.top-anchor': {
    color: colorsPalette.white,
    marginBottom: '2px',
    outline: 'unset',
    display: 'table',
    fontSize: '22px',
    letterSpacing: '-0.4',
    textDecoration: 'none',
    lineHeight: '24px',
    [MediaQueries.lg]: {
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: 'unset',
    },
    [MediaQueries.md]: {
      fontSize: '18px',
      lineHeight: '32px',
      letterSpacing: 'unset',
    },
    span: {
      borderBottom: `1px solid ${colorsPalette.grey90}`,
      paddingBottom: '0px',
    },

    '.top-anchor span': {
      borderBottom: `1px solid ${colorsPalette.grey90}`,
      paddingBottom: '2px',
    },
  },
});

export const subItems = css({
  'a.sub-item-anchor': {
    color: colorsPalette.hrcolor,
    fontSize: '18px',
    lineHeight: '32px',
    textTransform: 'none',
    fontWeight: '400',
    borderBottom: `1px solid ${colorsPalette.grey90}`,
    textDecoration: 'none',

    [MediaQueries.lg]: {
      fontSize: '16px',
      lineHeight: '24px',
      marginBottom: '8px',
      display: 'inline-block',
    },
    [MediaQueries.md]: {
      fontSize: '16px',
      lineHeight: '24px',
      marginBottom: '8px',
      display: 'inline-block',
      borderBottom: `1px solid ${colorsPalette.hrcolor}`,
    },
    [MediaQueries.sm]: {
      color: colorsPalette.phasetxt,
      fontSize: '16px',
      lineHeight: '24px',
      borderBottom: '0px',
    },

    'a.sub-item-anchor:last-child': {
      marginBottom: '0',
    },

    '.sub-item-anchor span': {
      border: 0,
      paddingBottom: '2px',

      [MediaQueries.lgAndUp]: {
        marginBottom: '0',
        borderBottom: '1PX',
        borderColor: colorsPalette.grey90,
        borderStyle: 'solid',
      },
    },
  },
});

export const shadowscroll = css({
  background:
    '-webkit-linear-gradient( rgba(57, 57, 57, 0) 0%, rgba(57, 57, 57, 1) 100% )',
  position: 'fixed',
  bottom: '0px',
  width: '99%',
  height: '64px',
  left: 0,
});

export const accordionStyle = css({
  paddingBottom: '30px',
  '.accordion__button': {
    display: 'flex',
    justifyContent: 'space-between',
    outline: 'none',

    '.left-part': {
      a: {
        textDecoration: 'none',
      },
    },

    '.right-part': {
      display: 'flex',

      '.sub-item-count': {
        color: colorsPalette.phasetxt,
        marginRight: '20px',

        a: {
          color: colorsPalette.phasetxt,
          textDecoration: 'none',
          fontSize: '14px',
        },
      },
    },
  },

  '.accordion__item': {
    marginBottom: '15px',
    padding: '10px 0px',
    borderBottom: `1px solid ${colorsPalette.grey90}`,
  },
  '.accordion__item :last-child': {},
  a: {
    color: colorsPalette.white,
    fontSize: '18px',
  },

  '.icon': {
    color: colorsPalette.white,
    // transition: 'transform .1s linear',
    transform: 'rotate(0deg)',
    fontSize: '9px',
  },
  '.accordion__panel': {
    marginTop: '11px',
    marginBottom: '11px',
    a: {
      color: colorsPalette.phasetxt,
      fontSize: '16px',
      lineHeight: '24px',
      margin: '12px 0px',
      textTransform: 'none',
      display: 'inline-block',
      fontWeight: '400',
      textDecoration: 'none',
    },
  },

  'div.accordion__button[aria-expanded="true"] .icon': {
    color: colorsPalette.white,
    // transition: 'transform .1s linear',
  },
  '.sub-item-count': {
    color: '#656566',
    marginRight: '20px',
  },
});
